import React, { useState } from 'react';
import { featuredProjects, otherProjects } from '../mockData';
import { Building, Users, Briefcase } from 'lucide-react';
import ProjectModal from './ProjectModal';

const Projects = () => {
  const [selectedProject, setSelectedProject] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const getCategoryIcon = (category) => {
    switch(category) {
      case 'Government': return <Building className="w-4 h-4" />;
      case 'Residential': return <Users className="w-4 h-4" />;
      case 'Commercial': return <Briefcase className="w-4 h-4" />;
      default: return null;
    }
  };

  const handleProjectClick = (project) => {
    setSelectedProject(project);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setTimeout(() => setSelectedProject(null), 300);
  };

  return (
    <section id="projects-section" className="projects-section">
      <div className="container">
        <div className="section-header">
          <span className="section-badge">Our Portfolio</span>
          <h2 className="section-title">Featured Projects</h2>
          <p className="section-description">
            Trusted by prestigious clients including Presidential Court, 
            ALDAR Properties, and major UAE developers
          </p>
        </div>

        {/* Featured Projects with Images */}
        <div className="projects-grid">
          {featuredProjects.map((project, index) => (
            <div 
              key={project.id} 
              className="project-card"
              data-testid={`project-card-${project.id}`}
              style={{ animationDelay: `${index * 0.1}s` }}
              onClick={() => handleProjectClick(project)}
            >
              <div className="project-image-wrapper">
                <img 
                  src={project.image} 
                  alt={project.title}
                  className="project-image"
                />
                <div className="project-overlay">
                  <span className="project-category">
                    {getCategoryIcon(project.category)}
                    {project.category}
                  </span>
                </div>
              </div>
              
              <div className="project-content">
                <h3 className="project-title">{project.title}</h3>
                <p className="project-client">Client: {project.client}</p>
                <p className="project-description">{project.description}</p>
                <span className="project-learn-more">Click to learn more →</span>
              </div>
            </div>
          ))}
        </div>

        {/* Other Projects - Text Only */}
        <div className="other-projects-section">
          <h3 className="other-projects-title">Additional Projects</h3>
          <div className="other-projects-list">
            {otherProjects.map((project) => (
              <div key={project.id} className="other-project-item">
                <div className="other-project-header">
                  <span className="other-project-category">
                    {getCategoryIcon(project.category)}
                    {project.category}
                  </span>
                  <h4 className="other-project-title">{project.title}</h4>
                </div>
                <p className="other-project-client">Client: {project.client}</p>
                <p className="other-project-description">{project.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <ProjectModal 
        project={selectedProject}
        isOpen={isModalOpen}
        onClose={handleCloseModal}
      />
    </section>
  );
};

export default Projects;
